import mixpanel from 'mixpanel-browser';

class MixpanelService {
  static instance = null;

  constructor() {
    if (!MixpanelService.instance) {
      mixpanel.init('b72fefbf04204eea4f94ee7ecbe4b096', {
        debug: false,
        persistence: 'localStorage',
        verbose: false,
        ignore_dnt: true,
        track_pageview: true,
        api_host: 'https://api-eu.mixpanel.com',
      });
      MixpanelService.instance = this;
    }

    return MixpanelService.instance;
  }

  trackEvent(eventName, properties = {}) {
    mixpanel.track(eventName, properties);
  }

  identifyUser(userId) {
    mixpanel.identify(userId);
  }

  set(userId, props) {
    mixpanel.people.set(userId, props);
  }

  reset() {
    mixpanel.reset();
  }
}

const mixpanelInstance = new MixpanelService();
Object.freeze(mixpanelInstance);


function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}


/**
 * Usage:
 *   trackEvent().init(userId)             – call once after login
 *   trackEvent().track('event', { ... })  – track any event
 *   trackEvent().reset()                  – call on logout
 */
export const trackEvent = () => ({
  init(userId) {
    // const anonId = 'abc-123';
    // const distinctId = uuidv4();
    // mixpanelInstance.trackEvent('Anonymous Event', { distinct_id: distinctId, anon_id: anonId });
    mixpanelInstance.set(userId, { $distinct_id: userId });
    mixpanelInstance.identifyUser(userId);
    mixpanelInstance.trackEvent('Authenticated Event', { user_id: userId });
  },
  track(eventName, properties = {}) {
    mixpanelInstance.trackEvent(eventName, {
      device_type: navigator.userAgent,
      ...properties,
    });
    if (window?.gtag) {
      window.gtag('event', eventName, properties);
    }
  },
  reset() {
    mixpanelInstance.reset();
  },
});

/**
 * Returns the last meaningful event string from a comma-separated match
 * string, or null when none is present.
 */
export const getLastEventString = (matchString) => {
  if (!matchString || typeof matchString !== 'string') return null;
  const parts = matchString
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s && s !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X');
  return parts.length > 0 ? parts[parts.length - 1] : null;
};

export default mixpanelInstance;
